import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Typography, TypographyStyles } from '@lacedltd/laced-components'

export const ProductDetailsItem = styled.div({
  '&:not(:last-child)': {
    marginBottom: tokens.spacing[7]
  }
})

export const ProductDetailsTitle = styled(Typography.Heading)({
  marginBottom: tokens.spacing[3]
})

export const ProductDetailsFeaturesListItem = styled.dl({
  ...TypographyStyles.footnote,
  display: 'flex',
  alignItems: 'flex-start',
  gap: tokens.spacing[3],
  margin: 0,
  padding: `${tokens.spacing[5]} 0`,

  '& + &': {
    borderTop: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[200]}`
  },

  dd: {
    textAlign: 'right',
    color: tokens.color.airJordan.p,
    marginLeft: 'auto',

    a: {
      fontSize: tokens.fontSize[2]
    }
  }
})
